import { useMutation, useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { APIError } from '../../../utils'
import { validateReviewEntry, ValidateReviewEntryProps } from '../query-api'

interface UseValidateReviewEntryProps {
  onError?: (error: APIError) => void
  onSuccess?: () => void
}

export const useValidateReviewEntry = (props: UseValidateReviewEntryProps = {}) => {
  const { onError, onSuccess } = props
  const queryClient = useQueryClient()

  const {
    mutate: validate,
    isLoading: isProcessing,
    ...rest
  } = useMutation((validationProps: ValidateReviewEntryProps) => validateReviewEntry(validationProps), {
    onError: (error: APIError) => {
      onError?.(error)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(QueryKeys.ReviewEntries)
      onSuccess?.()
    },
  })

  return { isProcessing, validate, ...rest }
}
